import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import Ico from './iconBox';

// import HomeBlog from '../assets/images/blog_1.jpg';
// import person1 from '../assets/images/person_1.jpg';
// import person2 from '../assets/images/person_2.jpg';
// import person3 from '../assets/images/person_3.jpg';
// import person4 from '../assets/images/person_4.jpg';
import hotelBanner from '../img/about-us-header.png';

import About1 from '../img/hotel.jpg';
import About2 from '../img/Apartments.jpg';
import About3 from '../img/Home Stay.jpg';
import About4 from '../img/Hostels.jpg';


import smallReview1 from '../img/4 (1).jpg';
import smallReview2 from '../img/5 (1).jpg';
import smallReview3 from '../img/6 (1).jpg';



class Home extends Component {
    state = {

    }
    componentDidMount(){
        window.scrollTo(0, 0)

    }
    render() {
        return (
            <div>
            
       
















<>
  





<>
 <section
  className="page-header py-5 text-center text-white"
  style={{
    position: 'relative',
    backgroundImage: `url(${hotelBanner})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '400px', // adjust as needed
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white'
  }}
>
  {/* Overlay for blur */}
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.4)', // semi-transparent dark layer
      backdropFilter: 'blur(5px)', // blur effect
      zIndex: 1
    }}
  ></div>

  <div style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
    <h1 className="display-4 fw-bold">Hotels in Karachi</h1>
    <p className="lead">Find Verified & Trusted Hotel Stays with Yovho</p>
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb justify-content-center mt-3">
        <li className="breadcrumb-item"><a href="/">Home</a></li>
        <li className="breadcrumb-item active" aria-current="page" style={{color:"white"}}>About Us</li>
      </ol>
    </nav>
  </div>
</section>






















<section id="about_yovho_modern" className="aboutModern_section">
  <div className="container-xl">
    <div className="row align-items-center">
      {/* Left Content */}
      <div className="col-md-6">
        <div className="aboutModern_left">
          <h5 className="aboutModern_tag">
            <i className="fa fa-leaf me-1" /> About YOVHO{" "}
            <i className="fa fa-leaf ms-1" />
          </h5>

          <h2 className="aboutModern_title">
            Verified Stays That Feel Like Home — Every Time
          </h2>

          <div className="aboutModern_tabs">
            <button className="aboutModern_tab active">Mission & Vision</button>
            <button className="aboutModern_tab">Focus On Customer</button>
          </div>

          <div className="aboutModern_text">
            <p>
              At <strong>YOVHO</strong>, we’re redefining the stay experience by
              bringing verified hotels, apartments, homestays, and hostels together on
              one trusted platform.  
              Our mission is to make finding a safe, reliable, and affordable stay
              effortless for every traveler.
            </p>
          </div>

          <div className="aboutModern_actions d-flex align-items-center mt-4">
            <a href="/about-us" className="aboutModern_btn">Learn More</a>
            <div className="aboutModern_avatars ms-3">
              <img src={smallReview1} alt="customer" />
              <img src={smallReview2} alt="customer" />
              <img src={smallReview3} alt="customer" />
              <span className="aboutModern_counter">
                <strong>3K+</strong> <br /> Happy Guests
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Right Images */}
      <div className="col-md-6" style={{marginTop:"30px"}}>
        <div className="aboutModern_right">
          <div className="aboutModern_gallery">
            <div className="aboutModern_column">
              <img src={About1} alt="Stay" />
              <img src={About2} alt="Apartment" />
            </div>
            <div className="aboutModern_column">
              <img src={About3} alt="Room" />
              <img src={About4} alt="Hotel" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


















<section id="about_pg" className="p-3">
  <div className="container-xl">

    {/* Stats Section */}
    <div className="row aboutStats_section mt-5 pt-4 pb-4">
      <div className="col-md-3 col-sm-6">
        <div className="aboutStats_item">
          <div className="aboutStats_inner row">
            <div className="col-md-3">
              <div className="aboutStats_iconBox">
                <span className="col_green font_50 lh-1">
                  <i className="fa fa-building" style={{color: "#19a529"}} />
                </span>
              </div>
            </div>
            <div className="col-md-9">
              <div className="aboutStats_text">
                <h3 className="mb-1">1.2k+</h3>
                <h6 className="mb-0">Listed Properties</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 col-sm-6">
        <div className="aboutStats_item">
          <div className="aboutStats_inner row">
            <div className="col-md-3">
              <div className="aboutStats_iconBox">
                <span className="col_green font_50 lh-1">
                  <i className="fa fa-users" style={{color: "#19a529"}} />
                </span>
              </div>
            </div>
            <div className="col-md-9">
              <div className="aboutStats_text">
                <h3 className="mb-1">3.5k+</h3>
                <h6 className="mb-0">Satisfied Clients</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 col-sm-6">
        <div className="aboutStats_item">
          <div className="aboutStats_inner row">
            <div className="col-md-3">
              <div className="aboutStats_iconBox">
                <span className="col_green font_50 lh-1">
                  <i className="fa fa-star" style={{color: "#19a529"}} />
                </span>
              </div>
            </div>
            <div className="col-md-9">
              <div className="aboutStats_text">
                <h3 className="mb-1">4.9</h3>
                <h6 className="mb-0">Average Rating</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 col-sm-6">
        <div className="aboutStats_item border-end-0">
          <div className="aboutStats_inner row">
            <div className="col-md-3">
              <div className="aboutStats_iconBox">
                <span className="col_green font_50 lh-1">
                  <i className="fa fa-handshake" style={{color: "#19a529"}} />
                </span>
              </div>
            </div>
            <div className="col-md-9">
              <div className="aboutStats_text">
                <h3 className="mb-1">850+</h3>
                <h6 className="mb-0">Successful Deals</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Rating Section */}
    <div className="row aboutRating_section mt-4 text-center">
      <div className="col-md-12">
        <p className="mb-0">
          <span className="fw-bold">Trusted by Thousands!</span>
          <span className="fw-bold ms-2">4.9</span> Rating out of
          <span className="fw-bold">5.0</span> based on
          <a href="#"> <span className="fw-bold">18,764</span> reviews</a>
          <span className="ms-2 fw-bold">
            <i className="fa fa-check-circle col_green" /> Verified Platform
          </span>
        </p>
      </div>
    </div>

  </div>
</section>



















{/* 

  <section id="about_pg" className="p_3">
    <div className="container-xl">
      <div className="row about_pg1">
        <div className="col-md-6">
          <div className="about_pg1l">
            <h5 className="family_1 icon_tag col_green">
              <i className="fa fa-leaf me-1" /> About Us{" "}
              <i className="fa fa-leaf ms-1" />
            </h5>
            <h1 className="font_50 mt-3">
              We provide the best tour facilities.{" "}
            </h1>
            <p>
    YOVHO is a global travel and hospitality platform designed to make travel safe, simple, and accessible. Our mission is to connect millions of travelers with memorable experiences, offering a variety of transportation options and verified places to stay — from homes and hostels to hotels.
  </p>
  <p>
    We believe that everyone deserves a stay they can trust. That's why every YOVHO-listed property is personally verified by our team to meet strict standards of cleanliness, safety, and comfort. Whether you're traveling with family, friends, solo, or for business, you can count on YOVHO for a certified and secure stay.
  </p>
  <p>
    Wherever you go, YOVHO is there for you. We offer 24/7 customer support, an inspection team, and our trained YOVHO Captains are available on-site or on-call, ready to assist whenever needed.
  </p>
  <p>
    But YOVHO isn't just for travelers—it's also a platform for entrepreneurs and small hospitality businesses. We empower hotels, guest houses, hostels, and homeowners by providing full-stack technology, branding, and operational support to help them increase their earnings and deliver a better guest experience.
  </p>
  <p>
    From instant bookings to live guest support, YOVHO is redefining travel in Pakistan and beyond with trust, technology, and a human touch.
  </p>

            <div className="about_pg1li row">
              <div className="col-md-6 col-sm-6">
                <div className="about_pg1lil bg_light rounded_1 p-3">
                  <div className="row about_pg1lili">
                    <div className="col-md-3">
                      <div className="about_pg1lilil">
                        <span className="bg-white text-center fs-2 col_green rounded-circle d-inline-block">
                          <i className="fa fa-medkit" />
                        </span>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <div className="about_pg1lilir">
                        <h5 className="mb-0">Safety First Always</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-6">
                <div className="about_pg1lil bg_light1 rounded_1 p-3 about_pg1lilo">
                  <div className="row about_pg1lili">
                    <div className="col-md-3">
                      <div className="about_pg1lilil">
                        <span className="bg-white text-center fs-4 col_green rounded-circle d-inline-block">
                          <i className="fa fa-user-plus" />
                        </span>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <div className="about_pg1lilir">
                        <h5 className="mb-0">Trusted Travel Guide</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="about_pg1li row mt-4">
              <div className="col-md-6 col-sm-6">
                <div className="about_pg1lil bg_light1 rounded_1 p-3 about_pg1lilo">
                  <div className="row about_pg1lili">
                    <div className="col-md-3">
                      <div className="about_pg1lilil">
                        <span className="bg-white text-center fs-2 col_green rounded-circle d-inline-block">
                          <i className="fa fa-calendar" />
                        </span>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <div className="about_pg1lilir">
                        <h5 className="mb-0">Time And Stress Savings</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-6">
                <div className="about_pg1lil bg_light rounded_1 p-3">
                  <div className="row about_pg1lili">
                    <div className="col-md-3">
                      <div className="about_pg1lilil">
                        <span className="bg-white text-center fs-2 col_green rounded-circle d-inline-block">
                          <i className="fa fa-user-graduate" />
                        </span>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <div className="about_pg1lilir">
                        <h5 className="mb-0">Expertise And Experience</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="explore_1rili row mt-4">
              <div className="col-md-6">
                <div className="explore_1rilil">
                  <h6 className="mb-0">
                    <a className="button" href="#">
                      Find Out More
                    </a>
                  </h6>
                </div>
              </div>
              <div className="col-md-6">
                <div className="explore_1rilir">
                  <h5 className="mb-0 fs-6">
                    <a href="#">
                      <i className="fa fa-play-circle font_50 me-1 align-middle col_yellow" />{" "}
                      Watch Tour
                    </a>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="about_pg1r position-relative">
            <div className="about_pg1ri">
              <div className="grid clearfix">
                <figure className="effect-jazz mb-0">
                  <a href="#">
                    <img src="img/54.jpg" className="w-100" alt="abc" />
                  </a>
                </figure>
                
              </div>
              </div>
            <div className="about_pg1ri1  position-absolute bottom-0 text-end w-100">
              <h5 className="mb-0 text-white rounded_1 p-3 bg_green d-inline-block">
                <span className="fs-1 align-middle">05</span>
                Years of experience
              </h5>
            </div>
          </div>
              <br/>
               <h2>What We Do</h2>
  <p>
    YOVHO is a global platform that empowers entrepreneurs and small hospitality businesses by offering a comprehensive technology suite designed to enhance revenue and streamline operations. We provide affordable, reliable accommodation that guests can book instantly with confidence.
  </p>
  <ul>
    <li>Maximize revenue through smart pricing and inventory management</li>
    <li>Establish a strong online presence across multiple channels</li>
    <li>Attract more guests and enhance their overall experience</li>
    <li>Ensure seamless, hassle-free daily operations</li>
    <li>Build a brand admired by both travelers and local residents</li>
  </ul>


            
        </div>
      </div>
      <div className="row about_pg2 mt-5 pt-4 pb-4">
        <div className="col-md-3 col-sm-6">
          <div className="about_pg2i">
            <div className="about_pg2i1 row">
              <div className="col-md-3">
                <div className="about_pg2i1l">
                  <span className="col_green font_50 lh-1">
                    <i className="fa fa-user" />
                  </span>
                </div>
              </div>
              <div className="col-md-9">
                <div className="about_pg2i1r">
                  <h3 className="mb-1">0.4k+</h3>
                  <h6 className="mb-0">Happy Traveler</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="about_pg2i">
            <div className="about_pg2i1 row">
              <div className="col-md-3">
                <div className="about_pg2i1l">
                  <span className="col_green font_50 lh-1">
                    <i className="fa fa-key" />
                  </span>
                </div>
              </div>
              <div className="col-md-9">
                <div className="about_pg2i1r">
                  <h3 className="mb-1">0.6k+</h3>
                  <h6 className="mb-0">Tours Success</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="about_pg2i">
            <div className="about_pg2i1 row">
              <div className="col-md-3">
                <div className="about_pg2i1l">
                  <span className="col_green font_50 lh-1">
                    <i className="fa fa-thumbs-up" />
                  </span>
                </div>
              </div>
              <div className="col-md-9">
                <div className="about_pg2i1r">
                  <h3 className="mb-1">32%</h3>
                  <h6 className="mb-0">Positives Review</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="about_pg2i border-end-0">
            <div className="about_pg2i1 row">
              <div className="col-md-3">
                <div className="about_pg2i1l">
                  <span className="col_green font_50 lh-1">
                    <i className="fa fa-user-graduate" />
                  </span>
                </div>
              </div>
              <div className="col-md-9">
                <div className="about_pg2i1r">
                  <h3 className="mb-1">6</h3>
                  <h6 className="mb-0">Travel Guide</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row about_pg3 mt-4 text-center">
        <div className="col-md-12">
          <p className="mb-0">
            <span className="fw-bold">Excellent!</span>
            <span className="fw-bold ms-2">5.0</span> Rating out of{" "}
            <span className="fw-bold">5.0</span> based on{" "}
            <a href="#">
              <span className="fw-bold">225353</span> reviews
            </a>{" "}
            <span className="ms-2 fw-bold">
              <i className="fa fa-umbrella  col_green" /> Tripadvisor
            </span>
          </p>
        </div>
      </div>
    </div>
  </section> */}










  <section class="why-choose-yovho">
  <div class="why-container">
    <div class="why-header">
      <h5><i class="fa fa-leaf"></i> Our Promise <i class="fa fa-leaf"></i></h5>
      <h2>Why Choose <span>Yovho</span></h2>
      <p>
        Discover what makes Yovho your trusted travel companion — where comfort,
        confidence, and convenience meet.
      </p>
    </div>

    <div class="why-grid">
      <div class="why-card">
        <div class="icon"><i class="fa fa-globe"></i></div>
        <h3>Verified Properties</h3>
        <p>
          Every stay listed on Yovho — from hotels to hostels — is verified for
          safety, comfort, and reliability, so you can book with complete
          confidence.
        </p>
      </div>

      <div class="why-card">
        <div class="icon"><i class="fa fa-dollar-sign"></i></div>
        <h3>Best Price Guarantee</h3>
        <p>
          Enjoy competitive rates on every booking. Yovho partners directly with
          verified hosts to offer transparent and fair prices — no hidden fees.
        </p>
      </div>

      <div class="why-card">
        <div class="icon"><i class="fa fa-calendar-check"></i></div>
        <h3>Instant Booking</h3>
        <p>
          With real-time availability and instant confirmations, booking your next
          stay is smooth, fast, and hassle-free.
        </p>
      </div>

      <div class="why-card">
        <div class="icon"><i class="fa fa-user-shield"></i></div>
        <h3>Trusted Community</h3>
        <p>
          Thousands of verified travelers and hosts trust Yovho. Real reviews.
          Real experiences. Real peace of mind.
        </p>
      </div>

      <div class="why-card">
        <div class="icon"><i class="fa fa-headset"></i></div>
        <h3>24/7 Guest Support</h3>
        <p>
          Our team is always available to assist — before, during, and after your
          stay — ensuring a stress-free experience.
        </p>
      </div>

      <div class="why-card">
        <div class="icon"><i class="fa fa-sync-alt"></i></div>
        <h3>Flexible Stays</h3>
        <p>
          From one night to long-term stays, Yovho offers flexible booking options
          tailored to your needs and comfort.
        </p>
      </div>
    </div>
  </div>
</section>



  {/* <section id="choose" className="p_3">
    <div className="container-xl">
      <div className="row vacation_1 text-center mb-4">
        <div className="col-md-12">
          <h5 className="family_1 icon_tag col_green">
            <i className="fa fa-leaf me-1" /> Who We Are{" "}
            <i className="fa fa-leaf ms-1" />
          </h5>
          <h1 className="font_50 mt-3 mb-0">Why Choose Tour Booking</h1>
        </div>
      </div>
      <div className="row choose_1">
        <div className="col-md-4">
          <div className="choose_1l p-4 px-3 bg_light border_1 rounded_1">
            <div className="choose_1li row">
              <div className="col-md-4">
                <div className="choose_1lil">
                  <span className="d-inline-block bg_light1 text-center rounded-circle text-center">
                    <i className="fa fa-globe" />
                  </span>
                </div>
              </div>
              <div className="col-md-8">
                <div className="choose_1lir">
                  <h5>Worldwide Coverage</h5>
                  <p className="mb-0">
                    Cras facilisis fermentum ex seda ullamcorper odio rutrum
                    accoun Phasellus auctor
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="choose_1l p-4 px-3 bg_light1 border_1 rounded_1">
            <div className="choose_1li row">
              <div className="col-md-4">
                <div className="choose_1lil">
                  <span className="d-inline-block bg_light text-center rounded-circle text-center">
                    <i className="fa fa-dollar" />
                  </span>
                </div>
              </div>
              <div className="col-md-8">
                <div className="choose_1lir">
                  <h5>Competitive Pricing</h5>
                  <p className="mb-0">
                    Burabitur convallis enim atnora ullamcorper sagittis. Morbi
                    nug scelerisque for thana.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="choose_1l p-4 px-3 bg_light border_1 rounded_1">
            <div className="choose_1li row">
              <div className="col-md-4">
                <div className="choose_1lil">
                  <span className="d-inline-block bg_light1 text-center rounded-circle text-center">
                    <i className="fa fa-calendar" />
                  </span>
                </div>
              </div>
              <div className="col-md-8">
                <div className="choose_1lir">
                  <h5>Fast Booking</h5>
                  <p className="mb-0">
                    Fermentum eitorx quis maximum Etiam luctus erat vulputate
                    urnan posuere convallis.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row choose_1 mt-4">
        <div className="col-md-4">
          <div className="choose_1l p-4 px-3 bg_light border_1 rounded_1">
            <div className="choose_1li row">
              <div className="col-md-4">
                <div className="choose_1lil">
                  <span className="d-inline-block bg_light1 text-center rounded-circle text-center">
                    <i className="fa fa-user-plus" />
                  </span>
                </div>
              </div>
              <div className="col-md-8">
                <div className="choose_1lir">
                  <h5>Guided Tours</h5>
                  <p className="mb-0">
                    Cras facilisis fermentum ex seda ullamcorper odio rutrum
                    accoun Phasellus auctor
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="choose_1l p-4 px-3 bg_light1 border_1 rounded_1">
            <div className="choose_1li row">
              <div className="col-md-4">
                <div className="choose_1lil">
                  <span className="d-inline-block bg_light text-center rounded-circle text-center">
                    <i className="fa fa-phone" />
                  </span>
                </div>
              </div>
              <div className="col-md-8">
                <div className="choose_1lir">
                  <h5>Best Support 24/7</h5>
                  <p className="mb-0">
                    Burabitur convallis enim atnora ullamcorper sagittis. Morbi
                    nug scelerisque for thana.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="choose_1l p-4 px-3 bg_light border_1 rounded_1">
            <div className="choose_1li row">
              <div className="col-md-4">
                <div className="choose_1lil">
                  <span className="d-inline-block bg_light1 text-center rounded-circle text-center">
                    <i className="fa fa-recycle" />
                  </span>
                </div>
              </div>
              <div className="col-md-8">
                <div className="choose_1lir">
                  <h5>Ultimate Flexibility</h5>
                  <p className="mb-0">
                    Fermentum eitorx quis maximum Etiam luctus erat vulputate
                    urnan posuere convallis.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> */}
  
<section id="explore_modern" className="exploreModern_section">
  <div className="container-xl">
    <div className="text-center mb-5">
      <h5 className="exploreModern_tag">
        <i className="fa fa-leaf me-1" /> Discover Verified Comfort with YOVHO{" "}
        <i className="fa fa-leaf ms-1" />
      </h5>
      <h1 className="exploreModern_title">Explore Your Perfect Stay</h1>
      <p className="exploreModern_subtitle">
        When Verified Stays Matter Most — Go With the Most Trusted.
      </p>
    </div>

    <div className="exploreModern_tabs text-center">
      <button className="exploreModern_tab active">
        <i className="fa fa-hotel" /> Hotel Stay
      </button>
      <button className="exploreModern_tab">
        <i className="fa fa-building" /> Apartment Stay
      </button>
      <button className="exploreModern_tab">
        <i className="fa fa-house-user" /> Home Stay
      </button>
      <button className="exploreModern_tab">
        <i className="fa fa-bed" /> Hostels
      </button>
    </div>

    <div className="exploreModern_cards row mt-5">
      {/* Hotel Stay */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="exploreModern_card">
          <div className="exploreModern_image">
            <img src={About1} alt="Hotel Stay" />
          </div>
          <div className="exploreModern_content">
            <h3>Hotel Stay</h3>
            <p>
              Stay in verified hotels offering premium comfort and trusted service
              across Karachi’s top locations.
            </p>
            <ul>
              <li>✔ Verified Properties</li>
              <li>✔ Premium Facilities</li>
            </ul>
            <a href="#" className="exploreModern_btn">Check Availability</a>
          </div>
        </div>
      </div>

      {/* Apartment Stay */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="exploreModern_card">
          <div className="exploreModern_image">
            <img src={About2} alt="Apartment Stay" />
          </div>
          <div className="exploreModern_content">
            <h3>Apartment Stay</h3>
            <p>
              Enjoy modern, family-friendly apartments designed for both short and
              long stays.
            </p>
            <ul>
              <li>✔ Fully Furnished</li>
              <li>✔ Family-Friendly</li>
            </ul>
            <a href="#" className="exploreModern_btn">Check Availability</a>
          </div>
        </div>
      </div>

      {/* Home Stay */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="exploreModern_card">
          <div className="exploreModern_image">
            <img src={About3} alt="Home Stay" />
          </div>
          <div className="exploreModern_content">
            <h3>Home Stay</h3>
            <p>
              Feel like a local with verified homestays offering authentic hospitality
              and comfort.
            </p>
            <ul>
              <li>✔ Local Hosts</li>
              <li>✔ Home Comforts</li>
            </ul>
            <a href="#" className="exploreModern_btn">Check Availability</a>
          </div>
        </div>
      </div>

      {/* Hostels */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="exploreModern_card">
          <div className="exploreModern_image">
            <img src={About4} alt="Hostel Stay" />
          </div>
          <div className="exploreModern_content">
            <h3>Hostels</h3>
            <p>
              Budget-friendly comfort and community vibes for solo travelers and
              students.
            </p>
            <ul>
              <li>✔ Clean & Secure</li>
              <li>✔ Prime Locations</li>
            </ul>
            <a href="#" className="exploreModern_btn">Check Availability</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

 











  <section id="team" className="p_3">
    <div className="container-xl">
      <div className="row vacation_1 text-center mb-4">
        <div className="col-md-12">
          <h5 className="family_1 icon_tag col_green">
            <i className="fa fa-leaf me-1" /> Tour Guide{" "}
            <i className="fa fa-leaf ms-1" />
          </h5>
          <h1 className="font_50 mt-3 mb-0">Our Travel Guide</h1>
        </div>
      </div>
      <div className="row team_1">
        <div className="col-md-3 col-sm-6">
          <div className="team_1l border_1">
            <div className="team_1l1 position-relative">
              <div className="team_1l1i p-4 bg_light1">
                <img
                  src="img/55.jpg"
                  alt="abc"
                  className="w-100 rounded-circle"
                />
              </div>
              <div className="team_1l1i1 position-absolute top-0">
                <img src="img/55.jpg" className="w-100" alt="abc" />
              </div>
              <div className="team_1l1i2 bg_back pt-4 pb-4 px-3 position-absolute top-0">
                <ul className="mb-0">
                  <li>
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-facebook" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-twitter" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-pinterest" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="team_1l2  p-3 text-center">
              <h4>Lorem Porta</h4>
              <h6 className="mb-0">Tour Guide</h6>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="team_1l border_1">
            <div className="team_1l1 position-relative">
              <div className="team_1l1i p-4 bg_light1">
                <img
                  src="img/56.jpg"
                  alt="abc"
                  className="w-100 rounded-circle"
                />
              </div>
              <div className="team_1l1i1 position-absolute top-0">
                <img src="img/56.jpg" className="w-100" alt="abc" />
              </div>
              <div className="team_1l1i2 bg_back pt-4 pb-4 px-3 position-absolute top-0">
                <ul className="mb-0">
                  <li>
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-facebook" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-twitter" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-pinterest" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="team_1l2  p-3 text-center">
              <h4>Nulla Quis</h4>
              <h6 className="mb-0">Tour Guide</h6>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="team_1l border_1">
            <div className="team_1l1 position-relative">
              <div className="team_1l1i p-4 bg_light1">
                <img
                  src="img/57.jpg"
                  alt="abc"
                  className="w-100 rounded-circle"
                />
              </div>
              <div className="team_1l1i1 position-absolute top-0">
                <img src="img/57.jpg" className="w-100" alt="abc" />
              </div>
              <div className="team_1l1i2 bg_back pt-4 pb-4 px-3 position-absolute top-0">
                <ul className="mb-0">
                  <li>
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-facebook" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-twitter" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-pinterest" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="team_1l2  p-3 text-center">
              <h4>Ipsum Sem</h4>
              <h6 className="mb-0">Tour Guide</h6>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="team_1l border_1">
            <div className="team_1l1 position-relative">
              <div className="team_1l1i p-4 bg_light1">
                <img
                  src="img/58.jpg"
                  alt="abc"
                  className="w-100 rounded-circle"
                />
              </div>
              <div className="team_1l1i1 position-absolute top-0">
                <img src="img/58.jpg" className="w-100" alt="abc" />
              </div>
              <div className="team_1l1i2 bg_back pt-4 pb-4 px-3 position-absolute top-0">
                <ul className="mb-0">
                  <li>
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-facebook" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-twitter" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </li>
                  <li className="mt-3">
                    <a className="text-white a_tag1" href="#">
                      <i className="fa-brands fa-pinterest" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="team_1l2  p-3 text-center">
              <h4>Eget Dolor</h4>
              <h6 className="mb-0">Tour Guide</h6>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
  <section id="investor_queries" className="py-5 bg-light">
  <div className="container">
    <div className="text-center mb-5">
      <h2 className="fw-bold text-dark">Investor Queries & Grievance Redressal</h2>
      <p className="text-muted">Reach out to our Compliance Officer for any investor-related inquiries.</p>
    </div>

    <div className="row g-4 justify-content-center">
      <div className="col-md-12">
        <div className="card shadow-sm border-0 rounded-3 p-4 h-100">
          <div className="card-body">
            <div className="mb-3">
              <h5 className="fw-bold"><i className="fa fa-user-tie me-2 text-success"></i>Ab-Abdullah</h5>
              <p className="mb-0 text-muted">Compliance Officer</p>
            </div>

            <div className="mb-3">
              <h6 className="fw-bold text-success"><i className="fa fa-map-marker-alt me-2"></i>Addresses</h6>
              <p className="mb-0">UAE: Business Bay, Dubai</p>
              <p className="mb-0">Pakistan: Karachi</p>
            </div>

            <div className="mb-3">
              <h6 className="fw-bold text-success"><i className="fa fa-phone me-2"></i>Phone</h6>
              <p className="mb-0"><a href="tel:+971555562053" className="text-decoration-none text-dark">UAE: +971 55 556 2053</a></p>
              <p className="mb-0"><a href="tel:+923166611136" className="text-decoration-none text-dark">Pakistan: +92 316 661 1136</a></p>
            </div>

            <div>
              <h6 className="fw-bold text-success"><i className="fa fa-envelope me-2"></i>Email</h6>
              <p className="mb-0"><a href="mailto:investors@yovho.com" className="text-decoration-none text-dark">investors@yovho.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


</>








</>



















        
          </div>
        )
    }
}

export default Home;